"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useDeferredQueryData_1 = require("./useDeferredQueryData");
function usePollQueryUntilData(channel, id) {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [count, setCount] = (0, react_1.useState)(0);
    const [data, query, querying, error] = (0, useDeferredQueryData_1.default)(channel, id);
    const killswitchRef = (0, react_1.useRef)(false);
    const start = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        if (killswitchRef.current) {
            return;
        }
        setLoading(true);
        killswitchRef.current = false;
        let result;
        while (result == null) {
            if (killswitchRef.current) {
                break;
            }
            setCount((x) => x + 1);
            result = yield query();
        }
        setLoading(false);
        return result;
    }), []);
    const stop = (0, react_1.useCallback)(() => {
        killswitchRef.current = true;
    }, []);
    return [data, start, stop, count, loading, error];
}
exports.default = usePollQueryUntilData;
